// Bundle Builder grid — 3-STEP flow (bogeybros-style): each step maps to a
// collection (Step 1 Corset Dress, Step 2 Leggings, Step 3 Silk Bandana by
// default). Grid shows the active step via the Section Rendering API; a
// quick-add marks the step done and auto-advances. Each step can pin a
// featured "hero" product first (e.g. the Rangi set) — if the hero isn't on
// page 1, its card is built client-side from /products/{handle}.js.
// Contract with panel JS: dispatches `bb:cart:changed` after cart mutations.
(function () {
  'use strict';

  var root = document.querySelector('[data-bb-root]');
  if (!root) return;

  var gridZone = root.querySelector('[data-bb-grid-zone]');
  var grid = root.querySelector('[data-bb-grid]');
  var stepBtns = Array.prototype.slice.call(root.querySelectorAll('[data-bb-step]'));
  if (!stepBtns.length) return;

  var state = { stepIdx: 0, sort: 'manual', page: 1, loading: false };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var activeStep = function () { return stepBtns[state.stepIdx]; };

  function sectionUrl() {
    return '/collections/' + encodeURIComponent(activeStep().dataset.collection) +
      '?sort_by=' + encodeURIComponent(state.sort) +
      '&page=' + state.page +
      '&section_id=bundle-builder-grid';
  }

  var sizeBtn = root.querySelector('[data-bb-size-chart]');
  var sizeModal = document.querySelector('[data-bb-size-modal]');

  // Size chart button follows the ACTIVE step (image set per step in customizer)
  function syncSizeChart() {
    if (!sizeBtn) return;
    sizeBtn.hidden = !activeStep().dataset.sizeChart;
  }

  function setStep(idx) {
    state.stepIdx = idx;
    state.page = 1;
    stepBtns.forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === idx)); });
    syncSizeChart();
    fetchGrid('replace');
  }

  function appendUnique(page) {
    while (page.firstElementChild) {
      var card = page.firstElementChild;
      var h = card.getAttribute && card.getAttribute('data-handle');
      if (h && grid.querySelector('[data-handle="' + h + '"]')) card.remove();
      else grid.appendChild(card);
    }
  }

  function fetchGrid(mode) {
    if (state.loading) return;
    state.loading = true;
    fetch(sectionUrl())
      .then(function (r) {
        if (!r.ok) throw new Error('grid fetch ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var page = doc.querySelector('[data-bb-grid-page]');
        var more = doc.querySelector('[data-bb-next-page]');
        if (!page) throw new Error('grid section markup missing');
        var oldMore = gridZone.querySelector('[data-bb-next-page]');
        if (oldMore) oldMore.remove();
        if (mode !== 'append') grid.innerHTML = '';
        appendUnique(page);
        if (more) gridZone.appendChild(more);
        if (mode !== 'append') pinHero();
      })
      .catch(function (err) {
        console.error('[bundle-builder]', err);
        grid.innerHTML = '<div class="bb-grid-error"><p>Could not load products.</p>' +
          '<button type="button" class="bb-load-more" data-bb-retry>RETRY</button></div>';
      })
      .then(function () { state.loading = false; });
  }

  // Pin the step's featured product first; build its card from the product JSON
  // endpoint when it lives on a later page of the collection.
  function pinHero() {
    var handle = activeStep().dataset.hero;
    if (!handle) return;
    var card = grid.querySelector('[data-handle="' + handle + '"]');
    if (card) { grid.prepend(card); return; }
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.available) return;
        grid.prepend(buildCard(p));
      })
      .catch(function () { /* hero optional — grid stays as-is */ });
  }

  function buildCard(p) {
    var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
    var vOpts = function (v) { return [v.option1, v.option2, v.option3].filter(function (o) { return o != null; }); };
    var avail = p.variants.filter(function (v) { return v.available; });
    var fv = avail[0] || p.variants[0];
    var fvOpts = vOpts(fv);
    var el = document.createElement('div');
    el.className = 'bb-card';
    el.setAttribute('data-bb-card', '');
    el.setAttribute('data-handle', p.handle);
    var imgUrl = p.featured_image
      ? p.featured_image + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=400'
      : '';
    var img = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '';
    // One select per option, values derived from variants (matches Liquid card markup)
    var optionSelects = '';
    if (p.variants.length > 1) {
      var optCount = fvOpts.length;
      var selects = [];
      for (var i = 0; i < optCount; i++) {
        var values = [];
        p.variants.forEach(function (v) {
          var val = vOpts(v)[i];
          if (val != null && values.indexOf(val) < 0) values.push(val);
        });
        selects.push('<select class="bb-card__variants" data-bb-option-select data-option-index="' + i + '">' +
          values.map(function (val) {
            return '<option value="' + esc(val) + '"' + (fvOpts[i] === val ? ' selected' : '') + '>' + esc(val) + '</option>';
          }).join('') + '</select>');
      }
      optionSelects = '<div class="bb-card__options">' + selects.join('') + '</div>';
    }
    el.innerHTML =
      '<div class="bb-card__media">' + img + '</div>' +
      '<h4 class="bb-card__title"></h4>' +
      '<div class="bb-card__price-row"><span class="bb-card__price" data-bb-price>' + money(fv.price) + '</span>' +
      '<s class="bb-card__compare" data-bb-compare' + (fv.compare_at_price > fv.price ? '>' + money(fv.compare_at_price) : ' hidden>') + '</s></div>' +
      optionSelects +
      '<button type="button" class="bb-card__add" data-bb-add data-variant-id="' + fv.id + '">QUICK ADD</button>';
    el.querySelector('.bb-card__title').textContent = p.title;
    var json = document.createElement('script');
    json.type = 'application/json';
    json.setAttribute('data-bb-variants', '');
    json.textContent = JSON.stringify(p.variants.map(function (v) {
      return { id: v.id, options: vOpts(v), available: v.available, price_cents: v.price, price: money(v.price), compare: v.compare_at_price > v.price ? money(v.compare_at_price) : null };
    }));
    el.appendChild(json);
    return el;
  }

  function cardVariants(card) {
    var el = card.querySelector('[data-bb-variants]');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }

  // One select per product OPTION (Size, Fabric, …). Resolve the variant from
  // the chosen combination — Fabric is a price tier on corsets, so price must
  // react to every option change.
  function onOptionChange(select) {
    var card = select.closest('[data-bb-card]');
    if (!card) return;
    var chosen = Array.prototype.map.call(
      card.querySelectorAll('[data-bb-option-select]'),
      function (s) { return s.value; }
    );
    var v = cardVariants(card).find(function (x) {
      return x.options && x.options.length === chosen.length &&
        x.options.every(function (o, i) { return o === chosen[i]; });
    });
    var price = card.querySelector('[data-bb-price]');
    var compare = card.querySelector('[data-bb-compare]');
    var add = card.querySelector('[data-bb-add]');
    if (!v) { // combination doesn't exist as a variant
      if (add) { add.disabled = true; add.textContent = 'UNAVAILABLE'; }
      return;
    }
    if (price) price.textContent = v.price;
    if (compare) {
      compare.hidden = !v.compare;
      if (v.compare) compare.textContent = v.compare;
    }
    if (add) {
      add.dataset.variantId = String(v.id);
      add.disabled = !v.available;
      add.textContent = v.available ? 'QUICK ADD' : 'UNAVAILABLE';
    }
  }

  function announceCartChanged(cart) {
    document.dispatchEvent(new CustomEvent('bb:cart:changed', { detail: { cart: cart } }));
    // Update the header count bubble directly (mirrors Minimog's own non-drawer
    // branch). Deliberately NOT emitting Minimog/Kaching "cart-update" — third
    // party listeners can hijack it (observed a redirect to /cart); the Kaching
    // drawer refetches contents when opened, so it never goes stale.
    document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('m:hidden', !cart.item_count);
    });
  }

  function advanceStep() {
    activeStep().classList.add('is-done');
    if (state.stepIdx < stepBtns.length - 1) setStep(state.stepIdx + 1);
  }

  function quickAdd(btn) {
    var variantId = Number(btn.dataset.variantId);
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    // cartRequest = serialized + >=900ms spacing + auto-retry with backoff:
    // the store's Cloudflare throttles BURSTS of cart calls (fast 3-step adds
    // returned challenge HTML -> step-3 error). Kaching bypass included.
    window.BBTiers.cartRequest('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _bundle: 'true' } }] }),
    })
      .then(function () {
        btn.textContent = 'ADDED ✓';
        btn.classList.add('is-added');
        return window.BBTiers.cartRequest('/cart.js')
          .then(function (cart) {
            announceCartChanged(cart);
            setTimeout(advanceStep, 600); // let the shopper see "ADDED ✓", then next step
          })
          .catch(function () {
            // add landed but the cart read kept failing — advance anyway,
            // panel will refetch truth on its own event
            document.dispatchEvent(new CustomEvent('bb:cart:changed'));
            setTimeout(advanceStep, 600);
          });
      })
      .catch(function (err) {
        if (err && err.unavailable) {
          btn.textContent = 'UNAVAILABLE';
          btn.disabled = false;
          return;
        }
        console.error('[bundle-builder] add', err);
        btn.textContent = 'ERROR — RETRY';
        btn.disabled = false;
      });
  }

  if (sizeModal) {
    sizeModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bb-modal-close]')) sizeModal.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') sizeModal.hidden = true;
    });
  }

  root.addEventListener('click', function (e) {
    var sizeOpen = e.target.closest('[data-bb-size-chart]');
    if (sizeOpen && sizeModal) {
      var url = activeStep().dataset.sizeChart;
      if (url) {
        sizeModal.querySelector('[data-bb-size-img]').src = url;
        sizeModal.hidden = false;
      }
      return;
    }
    var step = e.target.closest('[data-bb-step]');
    if (step) { setStep(stepBtns.indexOf(step)); return; }
    var more = e.target.closest('[data-bb-next-page]');
    if (more) {
      state.page = Number(more.dataset.bbNextPage) || state.page + 1;
      fetchGrid('append');
      return;
    }
    if (e.target.closest('[data-bb-retry]')) { fetchGrid('replace'); return; }
    var add = e.target.closest('[data-bb-add]');
    if (add) quickAdd(add);
  });

  root.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-bb-sort]');
    if (sort) {
      state.sort = sort.value;
      state.page = 1;
      fetchGrid('replace');
      return;
    }
    var select = e.target.closest('[data-bb-option-select]');
    if (select) onOptionChange(select);
  });

  setStep(0);
})();
